class PasswordValidator {
  constructor(passwordFieldId, passwordConfirmFieldId, warningBoxId, submitButtonId) {
    this.passwordField = document.querySelector(`#${passwordFieldId}`)
    this.passwordConfirmField = document.querySelector(`#${passwordConfirmFieldId}`)
    this.warningBox = document.querySelector(`#${warningBoxId}`)
    this.submitButton = document.querySelector(`#${submitButtonId}`)

    if (this.passwordField) {
      this.passwordField.addEventListener(
        'input',
        this.validatePassword.bind(this)
      )
    }

    if (this.passwordConfirmField) {
      this.passwordConfirmField.addEventListener(
        'input',
        this.validatePassword.bind(this)
      )
    }
  }

  async sha1Hash(str) {
    const encoder = new TextEncoder()
    const data = encoder.encode(str)

    // Use the subtle crypto API to hash the data
    const hashBuffer = await crypto.subtle.digest('SHA-1', data)

    // Convert the hash buffer to hexadecimal format
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('')

    return hashHex.toUpperCase()
  }

  async checkPassword(password) {
    const sha1Password = await this.sha1Hash(password)

    const prefix = sha1Password.substr(0, 5)

    // Send a GET request to the Pwned Passwords API
    const response = await fetch(
      `https://api.pwnedpasswords.com/range/${prefix}`
    )

    // Check if there is a match for the remaining characters of the hashed password
    const data = await response.text()

    const lines = data.split('\n')
    for (const line of lines) {
      const [suffix, count] = line.split(':')
      if (sha1Password.endsWith(suffix)) {
        return count
      }
    }

    return 0
  }

  async validatePassword() {
    const password = this.passwordField.value
    const passwordConfirm = this.passwordConfirmField.value

    const isLongEnough = password.length >= 8
    const hasUppercase = /[A-Z]/.test(password)
    const hasLowercase = /[a-z]/.test(password)
    const commonCount = await this.checkPassword(password)
    const isMatch = password === passwordConfirm

    this.warningBox.dataset.length = isLongEnough ? 'true' : 'false'
    this.warningBox.dataset.case = hasUppercase && hasLowercase ? 'true' : 'false'
    this.warningBox.dataset.common = commonCount < 100 ? 'true' : 'false'
    this.warningBox.dataset.match = isMatch ? 'true' : 'false'

    if (isMatch && isLongEnough && hasUppercase && hasLowercase && commonCount < 100) {
      this.submitButton.removeAttribute('disabled')
    } else {
      this.submitButton.setAttribute('disabled', true)
    }
  }
}

new PasswordValidator(
  'RegisterForm-password',
  'RegisterForm-password_confirmation',
  'password-validator',
  'submit-form'
)

class LoginTracking {
  constructor() {
    const loginBtnEle = document.querySelector(
      ".customer-login-form input[type='submit']"
    )
    loginBtnEle && loginBtnEle.addEventListener('click', () => {
      window.kortx('ktrack', 'signIn', {
        contentId: 'Sign-in',
        contentType: 'Sign-in',
        kid: '35071192$1728511', //DO NOT EDIT
      })
    })
  }
}

new LoginTracking()